import React from 'react';
import { useRecoilValue } from 'recoil';
import { optionsState } from '../options';
import { themeState } from '../theme';
import { truncate } from '../utils/truncate';
import { Value } from './Value';
export function ArrayPreview(_ref) {
  let {
    data
  } = _ref;
  const {
    hideObjectSize,
    previewElementsMaxCount,
    previewStringMaxLength
  } = useRecoilValue(optionsState);
  const theme = useRecoilValue(themeState);
  return /*#__PURE__*/React.createElement("i", null, !hideObjectSize && /*#__PURE__*/React.createElement(React.Fragment, null, '(', /*#__PURE__*/React.createElement("span", {
    style: {
      color: theme.valueNumberColor
    }
  }, data.length), ') '), /*#__PURE__*/React.createElement("span", null, "["), data.slice(0, previewElementsMaxCount).map((v, i, arr) => /*#__PURE__*/React.createElement("span", {
    key: i
  }, /*#__PURE__*/React.createElement(Value, {
    data: truncate(previewStringMaxLength)(v)
  }), i + 1 < arr.length ? ', ' : '')), data.length > previewElementsMaxCount && `, …`, /*#__PURE__*/React.createElement("span", null, "]"));
}